define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("CancelApprovalWorkflow", _StateAction, {
		m_module: "Workflow",
		m_tag: "CancelApprovalWorkflow",
		_bRequiresWorkflow: true,
		_bProhibitsWorkflow: false,

		_hasStateAccess: function(/*csi.def.Context*/ctx, /*Node*/master, /*Node*/revision) {
			return true;
		}
	});
});